import React, { useEffect, useRef } from "react";
import PropTypes from "prop-types";
import { useDispatch, useSelector } from "react-redux";

import mapboxgl from "mapbox-gl";
import "mapbox-gl/dist/mapbox-gl.css";
import { Spin, Slider } from "antd";
import {
  updateRequest,
  handlePlayPauseRequest,
} from "../../../store/actions/deviceMap";
import { mapboxToken, mapboxStyle,mapboxOwner, terrainId, satelliteId } from "../../../configuration";
import previousIcon from "../../../assets/devicemapplayericon/previous.svg";
import playIcon from "../../../assets/devicemapplayericon/play.svg";
import stopIcon from "../../../assets/devicemapplayericon/stop.svg";
import nextIcon from "../../../assets/devicemapplayericon/next.svg";
import {addDesignedButtons} from "../../Shipments/CreateShipments/map-utils"
import { returnPopups, popUpAndIndicator } from "../../../global/utility/Utils";
import getAddressfromLatLong from "../../../global/utility/getAddressfromLatLong";

function DeviceMap(props) {
  const { mapRef, intervalRef, popupRef } = props;
  mapboxgl.accessToken = mapboxToken;
  const dispatch = useDispatch();
  const { isLoading, isPlaying, mapData, currentIndex } = useSelector(
    (state) => ({
      isPlaying: state.deviceMap.isPlaying,
      isLoading: state.deviceMap.isLoading,
      mapData: state.deviceMap.data || [],
      currentIndex: state.deviceMap.currentIndex,
    })
  );

  const mapContainer = useRef(null);

  const validateCoord = (coord) => {
      if (coord && Array.isArray(coord) && coord.length > 1) {
        if (!isNaN(coord[0]) && !isNaN(coord[1])) {
          if (
            coord[0] >= -180 &&
            coord[0] <= 180 &&
            coord[1] >= -90 &&
            coord[1] <= 90
          ) {
            return true;
          }
          return false;
        }
        return false;
      } else {
        return false;
      }
    };

  useEffect(() => {
    const originCoordinates =
      Array.isArray(mapData) && mapData.length > 0
        ? mapData[0]?.geometry?.coordinates
        : [-117.53536, 34.044672];

    const currentCoordinates =
      Array.isArray(mapData) && mapData.length > 0
        ? mapData[mapData.length - 1]?.geometry?.coordinates
        : [-117.53536, 34.044672];
    const currentLastUpdated = Array.isArray(mapData) && mapData.length > 0
      ? mapData[mapData.length - 1]?.properties?.lastupdated
      : 'NA';
    const nav = new mapboxgl.NavigationControl({
      visualizePitch: true,
    });
    if (!mapboxgl.supported()) {
      console.error("WebGL is not supported in this browser. Map cannot be initialized.");
      return;
    }
    try {
      mapRef.current = new mapboxgl.Map({
        container: mapContainer.current,
      //  style:mapboxStyle,
         style: `mapbox://styles/${mapboxOwner}/${terrainId}`,
       // style: "mapbox://styles/mapbox/streets-v12",
        center: originCoordinates,
        zoom: 9,
      });
    } catch (e) {
      console.error("Failed to initialize map:", e);
      return;
    }
      mapRef.current.addControl(new mapboxgl.FullscreenControl(), "top-right");
      addDesignedButtons(mapRef.current, terrainId, satelliteId, mapboxOwner);
      mapRef.current.addControl(new mapboxgl.NavigationControl({ visualizePitch: true }), "top-right");
     //  mapRef.current.addControl(nav, "top-right");

    const currLoc = async () => {
      if (validateCoord(currentCoordinates)) {
      const address = await getAddressfromLatLong(currentCoordinates[1], currentCoordinates[0]);
      const addrHTML = `<div>
        ${address}
        <div style="margin-bottom: 7px"></div>
        <span style="font-weight: bold;color: #6F7171;">${currentLastUpdated}</span>
        </div>`;
      const popupstr = returnPopups({
        loc_type: "Current Location",
        Address: addrHTML,
        locationName: `${currentCoordinates[0]}, ${currentCoordinates[1]}`,
      });
      const indicator = `<div class="shipment-map-indicator-container">
                           <img src="/assets/destination-location.svg" style="width:35px; height:35px; position: absolute; top: -20px; left: -7px; z-index:999" alt="Start Marker"/>
                           <img src="/assets/map-Indicators.svg" style="width:20px; height:20px" alt="Start Marker"/>
                         </div>`;
      popUpAndIndicator(currentCoordinates, popupstr, indicator, mapRef.current);
    }
  }

  currLoc();
  }, [mapData]);

  async function drawMapMarker(index) {
    const map = mapRef.current;

    if (!map.isStyleLoaded()) {
      return;
    }

    const layers = map.getStyle().layers;
    if (layers) {
      layers.forEach((layer) => {
        if (layer.id.startsWith("line-") || layer.id.startsWith("marker-")) {
          map.removeLayer(layer.id);
        }
      });
    }

    const sources = map.getStyle().sources;
    if (sources) {
      Object.keys(sources).forEach((sourceId) => {
        if (sourceId.startsWith("line-") || sourceId.startsWith("marker-")) {
          map.removeSource(sourceId);
        }
      });
    }

    const customMarkers = document.querySelectorAll(".marker");
    customMarkers.forEach((marker) => marker.remove());
    mapData.forEach((_feature, i) => {
      const heatmapSourceId = `heatmap-source-${i}`;
      const heatmapLayerId = `heatmap-layer-${i}`;

      if (map.getLayer(heatmapLayerId)) {
        map.removeLayer(heatmapLayerId);
      }
      if (map.getSource(heatmapSourceId)) {
        map.removeSource(heatmapSourceId);
      }
    });

    if (Array.isArray(mapData) && mapData.length > 0) {
      const bounds = new mapboxgl.LngLatBounds();

      for (let i = 0; i <= index; i++) {
        const feature = mapData[i];
        const { coordinates } = feature?.geometry;
        let { id, color, borderColor, lastupdated, positiontype, latVal, lonVal } = feature.properties;
        color = index === id - 1 ? "#0089EC" : "#FF8027";
        const el = document.createElement("div");
        el.className = "marker";
        el.style.backgroundColor = color;
        el.style.width = "33px";
        el.style.height = "33px";
        el.style.borderRadius = "50%";
        el.style.display = "flex";
        el.style.alignItems = "center";
        el.style.justifyContent = "center";
        el.style.color = "#fff";
        el.style.fontSize = "14px";
        el.style.border = `2px solid ${borderColor || "#fff"}`;
        el.innerHTML = id;

        const address = await getAddressfromLatLong(latVal, lonVal);
        const addrHTML = `<div>
        ${address}
        <div style="margin-bottom: 7px"></div>
        <span style="font-weight: bold;color: #6F7171;">${lastupdated}</span>
        </div>`;
        const popupstr = returnPopups({
          loc_type: positiontype,
          locationName: `${lonVal}, ${latVal}`,
          Address: addrHTML,
        });

        new mapboxgl.Marker(el).setLngLat(coordinates).addTo(map);
        el.addEventListener("mouseenter", () => {
          if (popupRef.current) {
            popupRef.current.remove();
          }
          const popup = new mapboxgl.Popup({
            closeOnClick: false,
            closeButton: true,
          })
            .setLngLat(coordinates)
            .setHTML(`<div class="custom-map-popup">${popupstr}</div>`)
            .addClassName("customPopupCurrMapClass")
            .addTo(map);
          popupRef.current = popup;
        });

        bounds.extend(coordinates);
        if (i > 0) {
          const previousFeature = mapData[i - 1];
          map.addSource(`line-${i}`, {
            type: "geojson",
            data: {
              type: "Feature",
              geometry: {
                type: "LineString",
                coordinates: [
                  previousFeature.geometry.coordinates,
                  feature.geometry.coordinates,
                ],
              },
            },
          });

          map.addLayer({
            id: `line-${i}`,
            type: "line",
            source: `line-${i}`,
            layout: {
              "line-join": "round",
              "line-cap": "round",
            },
            paint: {
              "line-color": "#000",
              "line-width": 2,
              "line-dasharray": [2, 2],
            },
          });
        }
        const heatmapSourceId = `heatmap-source-${i}`;
        const heatmapLayerId = `heatmap-layer-${i}`;

        if (map.getLayer(heatmapLayerId)) {
          map.removeLayer(heatmapLayerId);
        }
        if (map.getSource(heatmapSourceId)) {
          map.removeSource(heatmapSourceId);
        }
        map.addSource(heatmapSourceId, {
          type: "geojson",
          data: {
            type: "FeatureCollection",
            features: mapData.slice(0, i + 1).map((feature) => ({
              type: "Feature",
              geometry: feature.geometry,
              properties: {
                weight: 1,
              },
            })),
          },
        });

        map.addLayer({
          id: heatmapLayerId,
          type: "heatmap",
          source: heatmapSourceId,
          minzoom: 0, // Ensure heatmap is visible at lower zooms
          maxzoom: 20,
          paint: {
            "heatmap-intensity": {
              stops: [
                [0, 0.4],
                [9, 2],
              ],
            },
            "heatmap-radius": {
              stops: [
                [0, 10], // Smaller radius at lower zoom levels
                [0, 30], // Larger radius at higher zoom levels to match the spread
              ],
            },
            "heatmap-weight": {
              property: "weight",
              type: "exponential",
              stops: [
                [0, 0],
                [9, 1],
              ],
            },
            "heatmap-color": [
              "interpolate",
              ["linear"],
              ["heatmap-density"],
              0,
              "rgba(33,102,172,0)",
              0.2,
              "#4dff4d",
              0.4,
              "#e6e600",
              0.5,
              "red",
            ],
            "heatmap-opacity": {
              stops: [
                [7, 1],
                [9, 0.6],
              ],
            },
          },
        });
      }
      map.fitBounds(bounds, {
        padding: 50,
      });
    }
  }

  useEffect(() => {
    if (Array.isArray(mapData) && mapData.length > 0 && isPlaying) {
      intervalRef.current = setInterval(() => {
        if (currentIndex < mapData.length) {
          drawMapMarker(currentIndex);
          dispatch(handlePlayPauseRequest(true));
        } else {
          dispatch(handlePlayPauseRequest(false));
          clearInterval(intervalRef.current);
        }
      }, 1000);
    } else {
      clearInterval(intervalRef.current);
    }
    return () => clearInterval(intervalRef.current);
  }, [currentIndex, dispatch, isPlaying, mapData]);

  const handlePreviousClick = (e) => {
    e.preventDefault();
    if (currentIndex-1 >= 0) {
      drawMapMarker(currentIndex-1);
      dispatch(
        updateRequest({
          currentIndex: currentIndex - 1,
        })
      );
    }
  };

  const handlePlayPause = (e) => {
    e.preventDefault();
    if (!Array.isArray(mapData) || mapData.length === 0){
      dispatch(handlePlayPauseRequest(false));
    }
    dispatch(handlePlayPauseRequest(!isPlaying));
  };

  const handleNextClick = (e) => {
    e.preventDefault();
    if (Array.isArray(mapData) && mapData.length > 0 && currentIndex < mapData.length - 1) {
      drawMapMarker(currentIndex+1);
      dispatch(
        updateRequest({
          currentIndex: currentIndex + 1,
        })
      );
    }
  };

  const handleSliderChange = (val) => {
    if (Array.isArray(mapData) && mapData.length > 0 && val < mapData.length - 1) {
      drawMapMarker(val);
      dispatch(
        updateRequest({
          currentIndex: val,
        })
      );
    }
  };

  const hasNoData = !isLoading && (!Array.isArray(mapData) || mapData.length === 0);

  return (
    <div className="device-map-container">
      <Spin spinning={isLoading} tip="Loading...">
          <div style={{ position: "relative", width: "100%", height: "60dvh" }}>
          <div ref={mapContainer} style={{ width: "100%", height: "100%" }} />
          {hasNoData && (
            <div
              className="d-flex flex-column align-items-center justify-content-center"
              style={{ position: "absolute", inset: 0, backgroundColor:"#ffffff", zIndex:10 }}
            >
              {/* <img src={NoIcon} width={30} height={30} alt="No Data" /> */}
              <span style={{ marginTop: "8px", fontSize: "14px", fontWeight: "500" }}>
                No data available for the selected time range, Try adjusting the filters.
              </span>
            </div>
          )}
        </div>
      </Spin>

      <div className="device-player">
        <div className="d-flex justify-content-start align-items-center">
          <div className="device-player-container">
            <button onClick={handlePreviousClick}>
              <img src={previousIcon} alt="Previous Icon" />
            </button>
            <button onClick={handlePlayPause} className="active">
              {!isPlaying && <img src={playIcon} alt="Play Icon" />}
              {isPlaying && <img src={stopIcon} alt="Stop Icon" />}
            </button>
            <button onClick={handleNextClick}>
              <img src={nextIcon} alt="Next Icon" />
            </button>
          </div>
          <div className="device-player-slider">
            <Slider
              styles={{
                track: {
                  backgroundColor: "#000000",
                },
                rail: {
                  backgroundColor: "#000000",
                },
                handle: {
                  backgroundColor: "#000000",
                },
              }}
              min={0}
              max={mapData?.length}
              value={currentIndex}
              onChange={handleSliderChange}
            />
          </div>
        </div>
      </div>
    </div>
  );
}

DeviceMap.propTypes = {
  mapRef: PropTypes.any.isRequired,
  intervalRef: PropTypes.any.isRequired,
  popupRef: PropTypes.any.isRequired,
};

export default DeviceMap;
